import React, { useState } from "react";
import ModelDropdown from "./ModelDropdown";
import { IconSquarePlus } from '@tabler/icons-react';
import FileDirectory from "../FileDirectory.json";

import { Menu, ActionIcon } from "@mantine/core";
import { leftNavMenuProps } from "../styleFile";

const AddModelButton = ({iconColour, leftNav = false}) => {
  const [hover, setHover] = useState(false)

  const ObjectCategoryArray = [...Object.keys(FileDirectory)]
  // const ObjectCategoryArray = [...Object.keys(FileDirectory), "text", "image"]

  // ADD TEXT TO END OF ARRAY AND THEN IN MODELDROPDOWN, HAVE TERNARY 
  // THAT ADDS AN EXTRA CUSTOM SELECT TO SELECT TEXT IF THE CATEGORY IS TEXT

  return (
    <Menu
      closeOnItemClick={false}
      trigger="hover"
      style={{ overflow: "visible" }}
      {...(leftNav ? leftNavMenuProps : {})}
    >
      <Menu.Target>
        <ActionIcon
          size={leftNav ? 28 : undefined}
          radius={leftNav ? 12 : undefined}
          variant="transparent"
          color={!hover ? iconColour.normal : iconColour.hover}
          onPointerOver={() => setHover(true)}
          onPointerLeave={() => setHover(false)}
          style={
            leftNav
              ? {
                  backgroundColor: hover ? (iconColour?.hoverBg || "#f3f4f6") : "transparent",
                  border: hover ? `1px solid ${iconColour?.border || "#e5e7eb"}` : "1px solid transparent",
                }
              : undefined
          }
        >
          <IconSquarePlus size={18} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown style={{ overflow: 'visible' }}>
        {ObjectCategoryArray.map((mapped, i) => (
          <Menu.Item key={i} style={{ overflow: 'visible' }}>
            <ModelDropdown category={mapped} />
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}

export default AddModelButton;